// extracted by mini-css-extract-plugin
module.exports = {"small":"VerticalSpace_small__UDraq","normal":"VerticalSpace_normal__28Cqn","large":"VerticalSpace_large__3lMFC"};